export const Role = {
	Member: 0,
	Admin: 1,
	Teacher: 2
};

const publicRoutes = [
	'/profil',
	'/profil/premium',
	'/profil/premium/abonament',
	'/profil/intrebari-frecvente',

	'/comanda/confirmata',
	'/tichete',
	'https://admiterepolitie.ro/blog',
	'/parteneri'
];

const learningPaths = [
	'/statistici',

	'/romana/mod-interactiv',
	'/romana/test',
	'/romana/materie',
	'/istorie/mod-interactiv',
	'/istorie/test',
	'/istorie/materie',
	'/engleza/mod-interactiv',
	'/engleza/test',
	'/engleza/materie',
	'/legislatie/mod-interactiv',
	'/legislatie/test',
	'/legislatie/materie',
	'/civica/mod-interactiv',
	'/civica/test',
	'/civica/materie',
	'/logica/test',
	'/logica/mod-interactiv',
	'/logica/materie',
	'/franceza/test',
	'/franceza/mod-interactiv',

	'/tco/test',
	'/tco/materie',

	'/simulare',
	'/simulare/start',
	'/simulare/istoric',

	'/clasament/rezultate-tara'
];

const studentPaths = ['/', '/performante', '/clasament/rezultate-personale'];

const adminAllowedPaths = [
	'/romana/materie/admin',
	'/istorie/materie/admin',
	'/engleza/materie/admin',
	'/legislatie/materie/admin',
	'/civica/materie/admin',
	'/logica/materie/admin',
	'/franceza/materie/admin',
	'/tco/materie/admin',

	'/admin/raportari/grile',
	'/admin/raportari/platforma',
	'/admin/grile',
	'/admin/users',
	'/admin/exams'
];

const teacherAllowedPaths = ['/profesor'];

export const rules = {
	0: {
		forbidden_actions: [],
		allowed_paths: [...publicRoutes, ...learningPaths, ...studentPaths]
	},
	1: {
		forbidden_actions: [],
		allowed_paths: [...publicRoutes, ...learningPaths, ...studentPaths, ...adminAllowedPaths]
	},
	2: {
		forbidden_actions: [],
		allowed_paths: [...publicRoutes, ...teacherAllowedPaths]
	}
};
